module.exports = __webpack_public_path__ + "img/linklogo4.3198dbae.png";